import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from '@chakra-ui/react';
import { FormField, FormInput, } from '@client/components/input/FormField';
import { PriceInput } from '@client/components/input/PriceInput';
import { AppDialog } from '@client/components/misc/AppDialog';
import { DialogConfirmFooter } from '@client/components/misc/DialogConfirmFooter';
import { LISTING_LIMITS } from '@heirloom/common/constants';
import { validatePersonalizationProfileInput } from '@heirloom/common/validation/profiles';
import { ValidationField, } from '@heirloom/common/validation/shared';
import { useEffect, useState } from 'react';
export const PersonalizationProfileDialog = ({ open, onClose, onConfirm, existingNames = [], saving = false, }) => {
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState(null);
    const [costCents, setCostCents] = useState(null);
    const [costError, setCostError] = useState(null);
    const [helperText, setHelperText] = useState('');
    const [helperTextError, setHelperTextError] = useState(null);
    useEffect(() => {
        if (!open) {
            setName('');
            setNameError(null);
            setCostCents(null);
            setCostError(null);
            setHelperText('');
            setHelperTextError(null);
        }
    }, [open]);
    const isDirty = () => !!name || costCents !== null || !!helperText;
    const handleClose = () => {
        if (isDirty()) {
            if (!window.confirm('Discard changes?'))
                return;
        }
        onClose();
    };
    const handleConfirm = () => {
        const errors = validatePersonalizationProfileInput({
            name,
            existingNames,
            costCents,
            helperText,
        });
        const findError = (field) => errors.find((e) => e.field === field)?.message ?? null;
        setNameError(findError(ValidationField.Name));
        setCostError(findError(ValidationField.Cost));
        setHelperTextError(findError(ValidationField.HelperText));
        if (errors.length > 0)
            return;
        const trimmedHelperText = helperText.trim();
        void onConfirm({
            name: name.trim(),
            costCents: costCents,
            helperText: trimmedHelperText || null,
        });
    };
    return (_jsx(AppDialog, { title: "New Personalization Profile", open: open, onCancel: handleClose, pending: saving, size: "xs", footer: _jsx(DialogConfirmFooter, { onCancel: handleClose, onConfirm: handleConfirm, confirmLabel: "Create", pending: saving }), children: _jsxs(Stack, { gap: 4, children: [_jsx(FormField, { label: "Name", error: nameError, required: true, children: _jsx(FormInput, { value: name, onChange: (e) => {
                            setName(e.target.value);
                            if (e.target.value.trim())
                                setNameError(null);
                        }, placeholder: "e.g. Engraving", disabled: saving }) }), _jsx(FormField, { label: "Cost", error: costError, required: true, children: _jsx(PriceInput, { value: costCents, onChange: (v) => {
                            setCostCents(v);
                            if (v && v > 0)
                                setCostError(null);
                        }, invalid: !!costError, disabled: saving, enclosed: true }) }), _jsx(FormField, { label: "Helper text", error: helperTextError, children: _jsx(FormInput, { value: helperText, onChange: (e) => {
                            setHelperText(e.target.value);
                            if (e.target.value.trim().length <=
                                LISTING_LIMITS.maxPersonalizationHelperTextLength)
                                setHelperTextError(null);
                        }, placeholder: "e.g. Add up to 20 characters.", disabled: saving }) })] }) }));
};
